// device states
export const OK = 0;
export const MALFUNCTION = 1;
export const PARTLY_MALFUNCTION = 2;
export const COMMUNICATION_FAILURE = 3;
export const NOT_CONNECTED_NO_DATA = -1;
export const UNKNOWN = -4;
